import { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "./button";
import { useVoltar } from "@/utils/voltar";

type PageHeaderProps = {
  title: string;
  icon?: ReactNode;
  total?: number;
  children?: ReactNode;
}

export const PageHeader = ({ title, icon, children, ...props }: PageHeaderProps) => {
  const voltar = useVoltar();
  return (
  <div className="flex flex-wrap items-center justify-between gap-4">
    <div className="flex items-center gap-3">
      <Button type="button" variant="ghost" size="icon" className="-ml-2 shrink-0" aria-label="Voltar" title="Voltar" onClick={() => voltar()}>
        <ArrowLeft className="h-5 w-5" />
      </Button>
      {icon}
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {'total' in props && (
          <p className="h-5 text-sm text-muted-foreground">
            {props.total !== undefined && `${props.total.toLocaleString('pt-BR')} ${props.total === 1 ? 'registro' : 'registros'}`}
          </p>
        )}
      </div>
    </div>
    {children && <div className="flex gap-2">{children}</div>}
  </div>
  );
};
